import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios, { authIsValid } from "../axios";
import { useCookies } from "react-cookie";
import ReactPaginate from "react-paginate";
import Loader from "../components/Loader";
import AddEditUser from "../components/EditUser";
import Delete from "../components/Delete";
import LoginContext from "../context/LoginContext";

function Users() {
  const { isLoggedIn, setIsLoggedIn } = useContext(LoginContext);
  const navigate = useNavigate();
  const [cookies, setCookies] = useCookies();
  const userData = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "",
    access_token: "",
  };
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editUserVisibility, setEditUserVisibility] = useState(false);
  const [deleteVisibility, setDeleteVisibility] = useState(false);
  const [userToDelete, setUserToDelete] = useState();
  const [userToAddData, setUserToAddData] = useState({ ...userData });
  const [userToEditData, setUserToEditData] = useState({ ...userData });
  const [searchValue, setSearchValue] = useState("");
  const [openAccordion, setOpenAccordion] = useState(false);
  const [addUserMessage, setAddUserMessage] = useState("");
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 25;
  const endOffset = itemOffset + itemsPerPage;
  const currentUsers = users.slice(itemOffset, endOffset);

  if (isLoggedIn === false) {
    navigate("/mixer");
  }

  const handleEditUser = (e) => {
    //setUserId(e.target.name); //name = user._id
    const targetUserData = currentUsers[e.target.id];
    setUserToEditData({ ...targetUserData });
    setEditUserVisibility(true);
  };

  const handleAddUserChange = (e) => {
    setUserToAddData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "/users/createUser",
        { ...userToAddData },
        { headers: { "x-access-token": cookies.access_token } }
      );
      if (response.data.message) {
        if (authIsValid(response.data.message) === false) {
          navigate("/mixer");
        } else {
          alert(response.data.message);
        }
      } else {
        //console.log(response);
        setAddUserMessage(response.data.message);
        fetchData();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const handleDelete = (e) => {
    setUserToDelete(e.target.name);
    console.log(`user: ${e.target.name}`);
    setDeleteVisibility(true);
  };

  const handlePageClick = (e) => {
    const newOffset = (e.selected * itemsPerPage) % users.length;
    setItemOffset(newOffset);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/users", {
        headers: {
          "x-access-token": cookies.access_token,
          requesterId: localStorage.getItem("userId"),
        },
      });
      if (response.data.message) {
        if (authIsValid(response.data.message) === false) {
          navigate("/mixer");
        } else {
          alert(response.data.message);
        }
      } else {
        setUsers([...response.data]);
      }
      setLoading(false);
    } catch (err) {
      console.error(`Error: ${err}`);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div id="addUser" className="">
        {loading ? <Loader /> : ""}
        {editUserVisibility && (
          <AddEditUser
            fetchData={fetchData}
            userData={userToEditData}
            setVisibility={(visible) => setEditUserVisibility(visible)}
          />
        )}
        {deleteVisibility && (
          <Delete
            itemId={userToDelete}
            itemToDelete={"user"}
            setVisibility={() => setDeleteVisibility(false)}
            updateList={fetchData}
          />
        )}
        <div className="adminHeader col-md-12">
          <h5 className="futuraBold">Users</h5>
        </div>
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-md-10 col-sm-12">
              <div
                id="usersSearch"
                className="row justify-content-center"
                style={{ marginTop: 20, marginBottom: 20 }}
              >
                <div className="form-group col-md-6 col-sm-12">
                  <label
                    htmlFor="searchInput"
                    className="col-md-4 col-sm-4 col-form-label futuraBold"
                    style={{
                      textAlign: "center",
                      fontWeight: 500,
                      fontSize: "18px",
                    }}
                  >
                    Search Users
                  </label>
                  <input
                    id="userSearchInput"
                    className="form-control input-lg"
                    name="searchInput"
                    value={searchValue}
                    onChange={handleSearch}
                  />
                </div>
                <div
                  className="col-md-3 col-xs-6"
                  style={{ paddingTop: "2px" }}
                >
                  <button
                    id="searchUsers"
                    className="btn btn-md"
                    type="button"
                    onClick={() => {
                      setOpenAccordion(!openAccordion);
                      if (openAccordion === false) {
                        setUserToAddData({ ...userData });
                        setAddUserMessage("");
                      }
                    }}
                  >
                    {openAccordion ? "Cancel" : "Add User"}
                  </button>
                </div>
              </div>
              <div
                className={
                  openAccordion
                    ? "openAccordion addUserContent"
                    : "addUserContent"
                }
              >
                {addUserMessage && (
                  <div className="col-md-12 text-center">
                    <p>{addUserMessage}</p>
                  </div>
                )}
                <form
                  onSubmit={handleAddUser}
                  id="addUserForm"
                  className="col-md-12"
                >
                  <div className="">
                    <div className="row form-group col-md-12 col-sm-12">
                      <label
                        htmlFor="addUserFirstName"
                        className="col-md-2 col-form-label text-center"
                      >
                        First Name:
                      </label>
                      <div className="col-md-4">
                        <input
                          id="addUserFirstName"
                          className="form-control input-lg"
                          name="firstName"
                          type="text"
                          required
                          value={userToAddData.firstName}
                          onChange={(e) => handleAddUserChange(e)}
                        />
                      </div>
                      <label
                        htmlFor="addUserlastName"
                        className="col-md-2 col-form-label text-center"
                      >
                        Last Name:
                      </label>
                      <div className="col-md-4">
                        <input
                          id="addUserLastName"
                          className="form-control input-lg"
                          name="lastName"
                          type="text"
                          required
                          value={userToAddData.lastName}
                          onChange={(e) => handleAddUserChange(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <div className="row form-group col-md-12 col-sm-12">
                      <label
                        htmlFor="addUserUsername"
                        className="col-form-label col-md-2 text-center"
                      >
                        Username (email):
                      </label>
                      <div className="col-md-4">
                        <input
                          id="addUsername"
                          className="form-control input-lg"
                          name="email"
                          type="email"
                          required
                          value={userToAddData.email}
                          onChange={(e) => handleAddUserChange(e)}
                        />
                      </div>
                      <label
                        htmlFor="addUserPassword"
                        className="col-form-label col-md-2 text-center"
                      >
                        Password:
                      </label>
                      <div className="col-md-4">
                        <input
                          id="addUserPassword"
                          className="form-control input-lg"
                          name="password"
                          type="password"
                          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" //1 lowercase, 1 uppercase, 1 number, 8+ chars
                          required
                          value={userToAddData.password}
                          onChange={(e) => handleAddUserChange(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row form-group col-md-12">
                    <div className="form-group col-md-6 col-sm-10">
                      <label
                        htmlFor="addUserRole"
                        className="control-label col-md-2 col-sm-4 text-center"
                        style={{ lineHeight: "38px" }}
                      >
                        Role:
                      </label>
                      <div className="c">
                        <select
                          id="addUserRole"
                          name="role"
                          className="form-select input-lg"
                          style={{ maxHeight: 38 }}
                          required
                          value={userToAddData.role}
                          onChange={(e) => handleAddUserChange(e)}
                        >
                          <option value="" hidden>
                            Choose...
                          </option>
                          <option value="ADMIN">ADMIN</option>
                          <option value="USER">USER</option>
                        </select>
                      </div>
                    </div>
                    <div id="passwordPattern" className="col-md-6">
                      <h6>Password must contain the following:</h6>
                      <p
                        className={
                          userToAddData.password.match(/[a-z]/g)
                            ? "valid"
                            : "invalid"
                        }
                      >
                        A <b>lowercase</b> letter
                      </p>
                      <p
                        className={
                          userToAddData.password.match(/[A-Z]/g)
                            ? "valid"
                            : "invalid"
                        }
                      >
                        A <b>capital (uppercase)</b> letter
                      </p>
                      <p
                        className={
                          userToAddData.password.match(/[0-9]/g)
                            ? "valid"
                            : "invalid"
                        }
                      >
                        A <b>number</b>
                      </p>
                      <p
                        className={
                          userToAddData.password.length > 7
                            ? "valid"
                            : "invalid"
                        }
                      >
                        Minimum <b>8 characters</b>
                      </p>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <button
                      className="btn btn-ryoForest col-md-2 col-sm-4"
                      type="submit"
                    >
                      Add User
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-md-center">
        <div className="col-md-12">
          <div className="row justify-content-center">
            <div className="col-md-10 col-xs-12">
              <table id="usersTable" className="table table-striped">
                <thead>
                  <tr>
                    <th className="col-md-3">Name</th>
                    <th className="col-md-3">Email</th>
                    <th className="col-md-2">Role</th>
                    <th className="col-md-2">Verified</th>
                    <th className="col-md-2"></th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.map((user, index) => (
                    <tr key={index} id={user._id}>
                      <td className="col-md-3">
                        {user.firstName} {user.lastName}
                      </td>
                      <td className="col-md-3">{user.email}</td>
                      <td className="col-md-2">{user.role}</td>
                      <td className="col-md-2">
                        {String(user.verified).toUpperCase()}
                      </td>
                      <td className="col-md-2" align="right">
                        <button
                          id={index}
                          name={user._id}
                          className="btn btn-md editUserBtn"
                          type="button"
                          onClick={handleEditUser}
                        >
                          Edit
                        </button>
                        <button
                          name={user._id}
                          className="btn btn-md deleteUserBtn"
                          type="button"
                          onClick={handleDelete}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div
              id="pageNumbersContainer"
              className="col-md-4 col-sm-6 col-xs-10 text-center"
            >
              <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={Math.ceil(users.length / itemsPerPage)}
                previousLabel="< prev"
                renderOnZeroPageCount={null}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Users;
